import FeedbacksDao from '../dao/feedbacks.dao';
import type { LiveClassFeedback } from '../interfaces';
import type { Environment } from '../interfaces/environment';

export abstract class FeedbacksService {
  static async submitFeedback(
    env: Environment,
    liveClassFeedback: LiveClassFeedback
  ) {
    const feedbackResponse = await FeedbacksDao.submitFeedback(
      env,
      liveClassFeedback
    );
    return feedbackResponse;
  }
}
